import { DashboardAPI } from "utils/api";

export const addUsersToOrganizationAPI = async ({ usersToInvite = [], addedBy = "", orgId = "" }) =>
    DashboardAPI({
        method: "POST",
        url: "/addUsersToOrganization",
        data: {
            usersToInvite,
            addedBy,
            orgId,
        },
    });

export const renameOrganizationAPI = async ({ orgId = "", newName = "", changeBy = "" }) =>
    DashboardAPI({
        method: "POST",
        url: "/renameOrganization",
        data: {
            orgId,
            newName,
            changeBy,
        },
    });

export const removeUserFromOrgAPI = async ({ usersToRemove = [], removedBy = "", orgId = "" }) =>
    DashboardAPI({
        method: "POST",
        url: "/removeUsersFromOrganization",
        data: {
            usersToRemove,
            removedBy,
            orgId,
        },
    });

export const changeUsersRolesOrgAPI = async ({ usersToChange = [], changesMadeBy = "", orgId = "" }) =>
    DashboardAPI({
        method: "POST",
        url: "/changeUsersRolesOrganization",
        data: {
            usersToChange,
            changesMadeBy,
            orgId,
        },
    });

export const getOrgLogoAPI = async ({ orgId = "" }) => {
    const res = await DashboardAPI({
        method: "GET",
        url: `/getOrgLogo/${orgId}`,
        responseType: "arraybuffer",
    });

    const { data } = res;
    const contentType = res.headers["content-type"];

    const base64String = Buffer.from(data, "binary").toString("base64");

    // console.log(base64String);

    return { base64String, contentType };
};

export const getOrganizationsByNameAPI = async ({ name }) =>
    DashboardAPI({
        method: "GET",
        url: `/organizations/getOrganizationsByName?organizationName=${encodeURIComponent(name)}`,
    });

export const checkOrganizationNameTakenAPI = async ({ name }) =>
    DashboardAPI({
        method: "GET",
        url: `/organizations/checkOrganizationNameTaken?organizationName=${encodeURIComponent(name)}`,
    });

export const createOrganizationAPI = async ({ name = "", orgType = "", createdBy = "", usersToInvite = [] }) =>
    DashboardAPI({
        method: "POST",
        url: "/organizations/createOrganization",
        data: {
            name,
            orgType,
            createdBy,
            usersToInvite,
        },
    });

// Moving models in or out of the shared folder goes through the API: it rewrites the access lists
// on the model documents, which members are not allowed to touch directly.
export const addModelsToOrgFolderAPI = async ({
    uid = "",
    orgId = "",
    modelIds = [],
    parentFolderId = null,
    fromOrgId = null,
}) =>
    DashboardAPI({
        method: "POST",
        url: "/organizations/addModelsToOrgFolder",
        data: {
            uid,
            orgId,
            modelIds,
            parentFolderId,
            fromOrgId,
        },
    });

export const removeModelsFromOrgFolderAPI = async ({ uid = "", orgId = "", modelIds = [] }) =>
    DashboardAPI({
        method: "POST",
        url: "/organizations/removeModelsFromOrgFolder",
        data: {
            uid,
            orgId,
            modelIds,
        },
    });

export const approveJoinRequestAPI = async ({ uid = "", orgId = "", userId = "" }) =>
    DashboardAPI({
        method: "POST",
        url: "/organizations/approveJoinRequest",
        data: {
            uid,
            orgId,
            userId,
        },
    });

export const declineJoinRequestAPI = async ({ uid = "", orgId = "", userId = "" }) =>
    DashboardAPI({
        method: "POST",
        url: "/organizations/declineJoinRequest",
        data: {
            uid,
            orgId,
            userId,
        },
    });

// Deleting runs server side: shared models go back to their owners, members are unwired, and the
// document and every subcollection under it are removed.
export const deleteOrganizationAPI = async ({ uid = "", orgId = "" }) =>
    DashboardAPI({
        method: "POST",
        url: "/organizations/deleteOrganization",
        data: {
            uid,
            orgId,
        },
    });

export const userRequestToJoinOrganizationAPI = async (orgId, userId) =>
    DashboardAPI({
        method: "POST",
        url: `/organizations/requestToJoinOrganization`,
        data: {
            orgId,
            userId,
        },
    });
